<template>
	<div class="message-sent">
		<template v-if="selectedMessage">
			<header class="message-sent__header">
				<p class="date-time">
					<span v-if="selectedMessage.date_created">{{ selectedMessage.date_created | dateFormatter('MMM D, YYYY') }}</span>
					<span v-if="selectedMessage.time_created"> {{ selectedMessage.time_created | time('HH:mm') }} </span>
				</p>

				<p>
					<label>To:</label>
					{{ selectedMessage.emails }}
				</p>
			</header>

			<div class="message-sent__message">
				<h3 class="subject">{{ selectedMessage.type || selectedMessage.subject }}</h3>
				<p class="message" v-html="selectedMessage.message"></p>
			</div>
		</template>
		<p class="empty" v-else>No selected Message</p>
	</div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
	computed: {
		...mapFields('message', {
			selectedMessage: 'selectedMessage'
		})
	}
}
</script>

<style lang="scss" scoped>
.message-sent {
	padding: 2em 0;
	background-color: #fff;
	border: .5px solid lighten($default-light, 12%);
	display: flex;
	flex-direction: column;

	&__header {
		margin: 0 3.5em;
		padding-bottom: 1em;
		border-bottom: .5px solid lighten($default-light, 12%);
		font-size: .9em;

		.date-time {
			color: $default-light;
			margin-bottom: 10px;
		}

		label {
			font-weight: bold;
			margin-right: 1em;
		}
	}

	&__message {
		padding: 1em 3.5em 2em 3.5em;
		flex: 1 1 auto;
		overflow-y: auto;
		word-break: break-all;

		.subject {
			margin: 1em 0;
			font-size: 1em;
			font-weight: bold;
			text-transform: capitalize;
		}
	}

	.empty {
		font-size: 1em;
		color: $default-light;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		height: 100%;
	}
}
</style>
